const searchSuggestions = () => ({
  url: new URL(window.location.href),

  searchFormIsOpen: false,
  searchInput: document.querySelector("#search_input"),
  searchResults: [],
  resultsCount: 0,
  currentSearchQuery: "",
  searchInputValue: "",
  searchForm: null,
  init() {
    this.searchForm = document.querySelector(".js-search-form__container form")
    this.searchInput.addEventListener(
      "input",
      this.debounce((event) => {
        this.onChange(event)
      }, 300).bind(this)
    )

    //this.searchInputValue = this.url.searchParams.get('q')

    window.addEventListener("open-search", () => {
      this.searchFormIsOpen = true
      setTimeout(()=> this.searchInput.focus(), 50)
      document.body.classList.add("overflow-hidden")
    })
    window.addEventListener("close-search", () => {
      this.searchFormIsOpen = false
      document.body.classList.remove("overflow-hidden")
      this.resetSearchForm()
    })

    if (this.searchInputValue) {
      this.getSearchResults(this.searchInputValue)
    }
  },
  resetSearchForm() {
    if (this.searchForm) {
      this.searchForm.reset()
      this.searchInputValue = ""
      this.searchResults = []
      this.resultsCount = 0
    }
  },
  onChange() {
    const searchTerm = this.searchInput.value

    if (!searchTerm.length) {
      this.searchResults = []
      this.resultsCount = 0
      this.currentSearchQuery = ""
      this.url.searchParams.delete("q")
      history.replaceState(
        {},
        null,
        window.location.origin + window.location.pathname
      )
      return
    }
    this.searchInputValue = searchTerm
    this.currentSearchQuery = `/search?q=${searchTerm}&type=product`
    this.url.searchParams.set("q", searchTerm)
    history.replaceState(null, null, "?q=" + searchTerm + "&type=product")

    this.getSearchResults(searchTerm)
  },
  getSearchResults(searchTerm) {
    fetch(
      `/search/suggest.json?q=${searchTerm}&resources[type]=product&resources[options][unavailable_products]=hide&resources[options][fields]=title,variants.title,product_type&resources[limit]=6`
    )
      .then((response) => response.json())
      .then((suggestions) => {
        const productSuggestions = suggestions.resources.results.products

        this.searchResults = productSuggestions
        this.resultsCount = this.searchResults.length
        /*document.documentElement.classList.add('search-lock');*/

        if (productSuggestions.length > 0) {
          const firstProductSuggestion = productSuggestions[0]
        }
      })
  },
  debounce(fn, wait) {
    let t
    return (...args) => {
      clearTimeout(t)
      t = setTimeout(() => fn.apply(this, args), wait)
    }
  },
})

export default searchSuggestions

document.addEventListener("alpine:init", () => {
  Alpine.data("searchSuggestions", searchSuggestions)
})